import * as tslib_1 from "tslib";
import * as esriLoader from 'esri-loader';
import { Subject } from 'rxjs';
import { environment } from '../environment';
var esriRequestMaxUrlLength = 1000;
var interceptedErrorSubject = new Subject();
var Interceptor = /** @class */ (function () {
    function Interceptor() {
    }
    Interceptor.addInterceptor = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.addedInterceptorPromise) return [3 /*break*/, 1];
                        this.addedInterceptorPromise = new Promise(function (resolve) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var _a, esriConfig, interceptor, paroadsInterceptor;
                            return tslib_1.__generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4 /*yield*/, esriLoader.loadModules(['esri/config'], window.esriConfig)];
                                    case 1:
                                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 1]), esriConfig = _a[0];
                                        esriConfig.request.maxUrlLength = esriRequestMaxUrlLength;
                                        interceptor = {
                                            urls: [environment.apiBaseUrl + "/arcgis/mapserver"],
                                            before: function (params) {
                                                var e_1, _a;
                                                // Always do work for authentication cookie
                                                var cookieRow = document.cookie.split('; ').map(function (item) { return item.split('='); }).find(function (item) { return item[0] === 'PDAuth_token'; });
                                                if (cookieRow) {
                                                    var pdAuthToken = cookieRow[1];
                                                    if (!params.requestOptions.headers) {
                                                        params.requestOptions.headers = {
                                                            'X-Auth-Token': pdAuthToken
                                                        };
                                                    }
                                                    else {
                                                        params.requestOptions.headers['X-Auth-Token'] = pdAuthToken;
                                                    }
                                                }
                                                params.requestOptions.withCredentials = true;
                                                // Deal with a bug in ESRI's code where a query to this endpoint doesn't move all the data out of the query string
                                                if (params.url.includes('/mapserver/dynamicLayer') && params.url.length > esriRequestMaxUrlLength) {
                                                    var url = new URL(params.url);
                                                    url.searchParams.forEach(function (val, key) {
                                                        params.requestOptions.query[key] = val;
                                                    });
                                                    url.search = '';
                                                    params.url = url.href;
                                                }
                                                // Deal with ESRI's theme bugs
                                                if (params.url.includes('/export')
                                                    && params.requestOptions.query.dynamicLayers
                                                    && (params.requestOptions.query.dynamicLayers.includes('uniqueValueInfos')
                                                        || params.requestOptions.query.dynamicLayers.includes('classBreakInfos'))) {
                                                    var parsedLayers = JSON.parse(params.requestOptions.query.dynamicLayers);
                                                    var modified_1 = false;
                                                    var _loop_1 = function (layer) {
                                                        if (layer.drawingInfo && layer.drawingInfo.renderer && layer.drawingInfo.renderer.classBreakInfos) {
                                                            /* This is needed because of a bug. This should be removed if possible.
                                                             * When using the numeric renderer, the first break doesn't renderer
                                                             * on the map until the slider is moved. This is probably due to us
                                                             * not building the renderer in the right way, but the solution eludes me.*/
                                                            var mins_1 = [];
                                                            layer.drawingInfo.renderer.classBreakInfos.forEach(function (cbi) {
                                                                mins_1.push(cbi.classMinValue);
                                                                delete cbi.classMinValue;
                                                            });
                                                            var min = mins_1.sort(function (a, b) { return a - b; })[0];
                                                            layer.drawingInfo.renderer.minValue = layer.drawingInfo.renderer.minValue || min || 0;
                                                            modified_1 = true;
                                                        }
                                                        if (layer.drawingInfo && layer.drawingInfo.renderer && layer.drawingInfo.renderer.uniqueValueInfos) {
                                                            /* This is needed because of a bug. This should be removed if possible.
                                                             * When a unique value is null it isn't included in the value, but
                                                             * if the value is a string of null, it doesn't query properly, so
                                                             * we have to replace it. */
                                                            layer.drawingInfo.renderer.uniqueValueInfos.forEach(function (uvi) {
                                                                if (uvi.value === undefined || (typeof uvi.value === 'string' && uvi.value.toLowerCase() === 'null')) {
                                                                    uvi.value = '-NULL-';
                                                                    modified_1 = true;
                                                                }
                                                            });
                                                        }
                                                    };
                                                    try {
                                                        for (var parsedLayers_1 = tslib_1.__values(parsedLayers), parsedLayers_1_1 = parsedLayers_1.next(); !parsedLayers_1_1.done; parsedLayers_1_1 = parsedLayers_1.next()) {
                                                            var layer = parsedLayers_1_1.value;
                                                            _loop_1(layer);
                                                        }
                                                    }
                                                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                                    finally {
                                                        try {
                                                            if (parsedLayers_1_1 && !parsedLayers_1_1.done && (_a = parsedLayers_1.return)) _a.call(parsedLayers_1);
                                                        }
                                                        finally { if (e_1) throw e_1.error; }
                                                    }
                                                    if (modified_1) {
                                                        params.requestOptions.query.dynamicLayers = JSON.stringify(parsedLayers);
                                                    }
                                                }
                                            },
                                            error: (function (er) {
                                                interceptedErrorSubject.next(er);
                                            })
                                        };
                                        esriConfig.request.interceptors.push(interceptor);
                                        paroadsInterceptor = {
                                            urls: [environment.apiBaseUrl + "/arcgis/paroads"],
                                            before: function (params) {
                                                if (params.requestOptions.query.returnCountOnly &&
                                                    !params.requestOptions.query.geometry) {
                                                    params.requestOptions.query.where = 'ROWNUM <= 100';
                                                }
                                            },
                                            error: (function (er) {
                                                interceptedErrorSubject.next(er);
                                            })
                                        };
                                        esriConfig.request.interceptors.push(paroadsInterceptor);
                                        //resolve finish promise
                                        resolve();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [3 /*break*/, 3];
                    case 1: 
                    //await finish promise
                    return [4 /*yield*/, this.addedInterceptorPromise];
                    case 2:
                        //await finish promise
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Interceptor.esriError = interceptedErrorSubject.asObservable();
    return Interceptor;
}());
export { Interceptor };
